import { STATE } from "./lifeSimulator";

// const HAT = new Image();
// HAT.src = "/faces/hat.png";
// const DIRECT = new Image();
// DIRECT.src = "/faces/direct.png";
// const FROWN = new Image();
// FROWN.src = "/faces/frown.png";
const DEFAULT_BACKUP = new Image();
DEFAULT_BACKUP.src = "/faces/default-backup.png";
// const SHADES = new Image();
// SHADES.src = "/faces/shades.png";
// const SMILEQUESTION = new Image();
// SMILEQUESTION.src = "/faces/smilequestion.png";

export function drawGrid({
  canvas,
  lifeSim,
  cellsWide,
  cellsHigh,
  cellSize,
  brianMode = true,
  usedFaces,
}) {
  const { width, height } = lifeSim.size();
  const widthDiff = width - cellsWide;
  const heightDiff = height - cellsHigh;
  const startingX = Math.floor(widthDiff / 2);
  const startingY = Math.floor(heightDiff / 2);

  const ctx = canvas.getContext("2d");
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  const SKIP = new Set();
  const CLEAR = new Set();

  function requiredSquareSize(candidateSize) {
    const modAdjust = candidateSize % 2 === 0 ? 1 : 0;
    if (candidateSize <= 1) return 1;
    if (candidateSize === 2) return 4;
    if (candidateSize === 3) return 8;
    return (
      candidateSize * candidateSize - Math.ceil(candidateSize / 2) - modAdjust
    );
  }

  function findLargestSquare(x, y) {
    let potentialSize = 2;
    const addToSkip = [];
    const addToClear = [];
    const widthTarget = width - startingX;
    const heightTarget = height - startingY;

    let lastAllowedMissing = 0;

    while (true) {
      const maybeAddToSkip = [];
      const maybeAddToClear = [];

      let deltaOne = potentialSize - 1; // lol deltaOne
      let deltaTwo = 0;
      const requiredSize = requiredSquareSize(potentialSize);
      const originalAllowedMissing =
        potentialSize * potentialSize - requiredSize - lastAllowedMissing;
      let allowedMissing = originalAllowedMissing;

      while (deltaTwo < potentialSize && allowedMissing >= 0) {
        const xOne = x + deltaOne;
        const xTwo = x + deltaTwo;
        const yOne = y + deltaOne;
        const yTwo = y + deltaTwo;

        const xLarge = xOne >= widthTarget || xTwo >= widthTarget;
        const yLarge = yOne >= heightTarget || yTwo >= heightTarget;

        if (xLarge || yLarge) {
          allowedMissing -= 1;
          deltaTwo += 1;
          continue;
        }

        let candidates = [
          [xOne, yTwo],
          [xTwo, yOne],
        ];
        if (xOne === xTwo && yOne === yTwo) candidates = [[xOne, yTwo]];

        for (const candidate of candidates) {
          const [candidateX, candidateY] = candidate;
          const cell = lifeSim.getActiveCell(candidateX, candidateY);
          if (cell !== STATE.ALIVE) {
            allowedMissing -= 1;
            maybeAddToClear.push(candidate);
            // maybeAddToSkip.push(candidate);
          } else if (SKIP.has(`${candidateX}-${candidateY}`)) {
            allowedMissing -= 1;
            // maybeAddToClear.push(candidate);
          } else {
            maybeAddToSkip.push(candidate);
          }
        }

        deltaTwo += 1;
      }

      if (allowedMissing < 0) {
        break;
      }

      addToSkip.push(...maybeAddToSkip);
      addToClear.push(...maybeAddToClear);
      potentialSize += 1;
      lastAllowedMissing = originalAllowedMissing - allowedMissing;
    }

    addToSkip.forEach(([skipX, skipY]) => {
      SKIP.add(`${skipX}-${skipY}`);
    });
    addToClear.forEach(([clearX, clearY]) => {
      CLEAR.add(`${clearX}-${clearY}`);
    });
    return potentialSize - 1;
  }

  ctx.fillStyle = "#38bdf8";
  for (let x = 0; x < cellsWide; x++) {
    for (let y = 0; y < cellsHigh; y++) {
      const cellX = startingX + x;
      const cellY = startingY + y;
      if (brianMode && SKIP.has(`${cellX}-${cellY}`)) continue;

      const cellState = lifeSim.getActiveCell(cellX, cellY);
      if (cellState === STATE.ALIVE) {
        const squareSize = findLargestSquare(cellX, cellY);
        const posX = x * cellSize;
        const posY = y * cellSize;
        if (brianMode) {
          let img;
          if (usedFaces.length <= 0) {
            img = DEFAULT_BACKUP;
          } else {
            const idx = squareSize - 1;
            if (idx < usedFaces.length) {
              img = usedFaces[idx].img;
            } else {
              img = usedFaces[usedFaces.length - 1].img;
            }
          }

          ctx.drawImage(
            img,
            posX,
            posY,
            squareSize * cellSize,
            squareSize * cellSize
          );
        } else {
          ctx.fillRect(posX, posY, cellSize, cellSize);
        }
      }
    }
    CLEAR.forEach((s) => {
      let [clearX, clearY] = s.split("-");
      clearX = parseInt(clearX, 10) - startingX;
      clearY = parseInt(clearY, 10) - startingY;

      ctx.clearRect(clearX * cellSize, clearY * cellSize, cellSize, cellSize);
    });
  }

  // add grid lines
  ctx.strokeStyle = "#0369a1";
  ctx.lineWidth = 1;
  for (let x = 0; x <= cellsWide; x++) {
    let posX = x * cellSize;
    if (posX === 0) posX += 1;
    ctx.beginPath();
    ctx.moveTo(posX, 0);
    ctx.lineTo(posX, cellsHigh * cellSize);
    ctx.stroke();
  }

  for (let y = 0; y <= cellsHigh; y++) {
    let posY = y * cellSize;
    if (posY === 0) posY += 1;
    ctx.beginPath();
    ctx.moveTo(0, posY);
    ctx.lineTo(cellsWide * cellSize, posY);
    ctx.stroke();
  }
}
